import { generateRequest } from './request.js';
import { AveRequestEvents } from '../events.js';
/**
 * Starts an AVE session.
 * If a session is already running, the current session is automatically ended.
 *
 * Example:
 * ```
 * [{
 *   "meta": {
 *     "name": "AVEStartSession",
 *     "type": "REQUEST",
 *     "lastUpdate": true
 *   },
 *   "data": {
 *     "sessionId": "1234...",
 *     "client": "MiWi",
 *     "ConsumptionDataState": "Enable",
 *     "LoadingScreen": "Auto",
 *     "Vehicle": {
 *       "PrStringList": ["50362,8YARWY,1004"],
 *       "EngineCode": "",
 *       "ModelYear": "",
 *       "ModelRevision": "MP1",
 *       "Animations": [{
 *         "AnimationIds": [],
 *         "Direction": "forward",
 *         "Skip": true
 *       }],
 *       ResetCar": true,
 *       "LoadingScreen": "Auto",
 *       "ConsumptionData": [
 *         "Wltp Data,",
 *         "H₂O CO₂\n\n"
 *       ],
 *       "PreserveCarAnimationStates": true
 *     },
 *     "Camera": {
 *       "cameraId": "AVP2D_A_4_000",
 *       "transition": {
 *         "movementMode": <string>
 *       }
 *     }
 *   }
 * }]
 * ```
 */
export function generateStartSessionRequest({ sessionId, client, messageId, consumptionDataState, vehicle, environment, camera, loadingScreen }) {
    return generateRequest({
        messageId,
        name: AveRequestEvents.AVEStartSession,
        data: {
            sessionId,
            client,
            ConsumptionDataState: consumptionDataState,
            Vehicle: vehicle
                ? {
                    PrStringList: vehicle.prStringList,
                    EngineCode: vehicle.engineCode,
                    ModelYear: vehicle.modelYear,
                    Animations: vehicle.animations,
                    ResetCar: vehicle.resetCar,
                    LoadingScreen: vehicle.loadingScreen,
                    ConsumptionData: vehicle.consumptionData,
                    PreserveCarAnimationStates: vehicle.preserveCarAnimationStates,
                    ModelRevision: vehicle.modelRevision
                }
                : undefined,
            Environment: environment
                ? {
                    EnvironmentName: environment.environmentName,
                    PreserveCarAnimationStates: environment.preserveCarAnimationStates,
                    LoadingScreen: environment.loadingScreen
                }
                : undefined,
            Camera: camera
                ? {
                    CameraId: camera.cameraId,
                    Transition: camera.transition
                }
                : undefined,
            LoadingScreen: loadingScreen
        }
    });
}
/**
 * End an AVE session.
 *
 * Notes:
 * - Aborts loading of cars and environments.
 * - Loads the default environment.
 * - Unloads current car.
 *
 * Example:
 * ```
 * [{
 *   "meta": {
 *     "name": "AVEEndSession",
 *     "type": "REQUEST",
 *     "lastUpdate": true
 *   },
 *   "data": {}
 * }]
 * ```
 */
export function generateEndSessionRequest({ messageId } = {}) {
    return generateRequest({ messageId, name: AveRequestEvents.AVEEndSession });
}
//# sourceMappingURL=session.js.map